<div class="contentArea" *ngIf="!loadingHome">
  <div class="innerContainerEstadoTramite" *ngIf="showComponent">
    <div class="primaryContent">
      <ion-grid
        class="ion-no-padding"
        [ngClass]="showErrorScreen ? 'ion-hide' : ''"
      >
      <ion-row [ngClass]="{'ion-margin-top-movil': isMobile}">
          <h2 #tituloEstadoTramitePensionElement><strong>Revisa el estado de tu trámite de pensión</strong></h2>
      </ion-row>

      <ion-row *ngIf="isMobile">
          <div class="help-container">
              <button type="button" class="help-container-header" (click)="toggleHelp()">
                  <p>¿Necesitas ayuda?</p>
                  <ion-icon class="arrow" [class.open]="isOpenHelp" name="chevron-down-outline"></ion-icon>
              </button>
             <div class="help-card" *ngIf="isOpenHelp">
                  <ng-container *ngIf="!isEtapa; else isPreguntasFrecuentes">
                    <p>Solicita una Video atención con uno de nuestros ejecutivos</p>
                  </ng-container>
                  <ng-template #isPreguntasFrecuentes>
                    <p>Solicita una Video atención con uno de nuestros ejecutivos  o revisa las preguntas frecuentes</p>
                  </ng-template>
                  
                  <button type="button" class="help-card-button" (click)="goToVideoAtencion()">
                    <span class="schedule-button">Agendar Video Atención</span>
                    <ion-icon name="open-outline"></ion-icon>
                  </button>
                  <button *ngIf="isEtapa" type="button" class="help-card-button" (click)="preguntasFrecuentes()">
                    <span class="schedule-button">Revisar Preguntas frecuentes</span>
                    <ion-icon name="open-outline"></ion-icon>
                  </button>
                </div>
          </div>
      </ion-row>

      <ion-row [ngClass]="{'ion-margin-top': !isMobile}">
            <app-estado-tramite-pension-stepper style="width: 100%;">
            </app-estado-tramite-pension-stepper>
      </ion-row>

      <ion-row class="ion-margin-top-router">
          <router-outlet></router-outlet>
      </ion-row>

      </ion-grid>
    </div>
    <div class="secondaryContent" *ngIf="!showErrorScreen">
      <app-right-side-info-column
        [data]="rightColumnData"
        [isHelp]="true"
        (idRightColumnEmit)="scrollTo($event)"
      ></app-right-side-info-column>
    </div>
  </div>
</div>

<div class="contentArea" *ngIf="loadingHome && !servsError">
  <div class="innerContainerEstadoTramite" *ngIf="showComponent">

    <div class="primaryContent">
      <ion-grid
        class="ion-no-padding"
        [ngClass]="showErrorScreen ? 'ion-hide' : ''"
      >
      <ion-skeleton-text
          animated
          style="
            width: 60%;
            height: 25px;
            border-radius: 12px;
            margin-bottom: 23px;
          "
        ></ion-skeleton-text>
        <ion-skeleton-text
          animated
          style="
            width: 90%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 40px;
          "
        ></ion-skeleton-text>

        <ion-skeleton-text
          animated
          style="
            width: 50%;
            height: 24px;
            border-radius: 12px;
            margin-bottom: 3.5px;
          "
        ></ion-skeleton-text>
        <ion-skeleton-text
          animated
          style="
            width: 90%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 48px;
          "
        ></ion-skeleton-text>

        <ion-skeleton-text
          animated
          style="
            width: 65%;
            height: 24px;
            border-radius: 12px;
            margin-bottom: 3.5px;
          "
        ></ion-skeleton-text>
        <ion-skeleton-text
          animated
          style="
            width: 80%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 24px;
          "
        ></ion-skeleton-text>
      </ion-grid>
    </div>
    <div class="secondaryContent" *ngIf="!showErrorScreen">
      <ion-skeleton-text
          animated
          style="
            width: 60%;
            height: 25px;
            border-radius: 12px;
            margin-bottom: 23px;
          "
        ></ion-skeleton-text>
        <ion-skeleton-text
          animated
          style="
            width: 90%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 40px;
          "
        ></ion-skeleton-text>

        <ion-skeleton-text
          animated
          style="
            width: 50%;
            height: 24px;
            border-radius: 12px;
            margin-bottom: 3.5px;
          "
        ></ion-skeleton-text>
        <ion-skeleton-text
          animated
          style="
            width: 90%;
            height: 96px;
            border-radius: 12px;
            margin-bottom: 48px;
          "
        ></ion-skeleton-text>
    </div>

  </div>
</div>

<app-generic-error 
*ngIf="servsError"
[ops]="errorOps" 
[retryAttempt]="attempt" 
(retryEvent)="onRetryEvent()"
(goToEvent)="onGoToEvent()">
</app-generic-error>